<script>
export default {
  name: 'MailErrorsDialog',
  props: {
    mails: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  created() {
    this.isVisible = true;
  },
  beforeDestroy() {
    this.close();
  },
  methods: {
    close() {
      this.isVisible = false;
      this.$emit('close');
    },
  },
};
</script>

<template>
  <div>
    <v-dialog
      v-model="isVisible"
      max-width="800px"
      persistent
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          <v-alert :value="true" color="error" outline>
            Einige Emails konnten nicht versendet werden.
          </v-alert>
        </v-card-title>

        <v-card-text>
          <v-list two-line>
            <template v-for="(item, index) in mails">
              <v-list-tile :key="item.title" avatar ripple>
                <v-list-tile-content>
                  <v-list-tile-title class="black--text">
                    Benutzername: {{ item.username }}
                  </v-list-tile-title>

                  <v-list-tile-sub-title class="info--text">
                    Email: {{ item.email }}
                  </v-list-tile-sub-title>

                  <v-list-tile-sub-title class="red--text" style="text-decoration: underline;">
                    Fehlermeldung: {{ item.errorMessage }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-divider v-if="index + 1 < mails.length" :key="index"/>
            </template>
          </v-list>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn flat color="red darken-2" class="no-text-transform" @click="close">
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
